import { render, staticRenderFns } from "./PanelDeleteDataSource.vue?vue&type=template&id=63039460&"
import script from "./PanelDeleteDataSource.vue?vue&type=script&lang=js&"
export * from "./PanelDeleteDataSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports